import Keycloak from 'keycloak-js';

const keycloak = Keycloak({
  url: process.env.REACT_APP_IDP_URL || '',
  realm: process.env.REACT_APP_IDP_REALM || '',
  clientId: process.env.REACT_APP_IDP_CLIENT_ID || '',
});

export const initOptions = {
  onload: 'check-sso',
  flow: 'implicit',
  pkceMethod: 'S256',
};

export default keycloak;
